import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";

/**
 * used as a "DTO" to simplify display employee information display in the scheduler/calendar
 */
class CalendarEmployeeDisplay {
    public Name: string;
    public Title: string;
    public Specialities: string[];
    public ContactId: string;
    public ContactFacetId: string;
    public EmployeeId: string;
    public ActiveSiteId: string;
    public AppointmentCount: number;
    public AvailabilityCount: number;
    public HasScheduledRuleset: boolean;
    public EmployeeLastName: string;

    public constructor() {
        this.Specialities = [];
        this.AppointmentCount = 0;
        this.AvailabilityCount = 0;
    }

    public static FromUIModel(model: EmployeeUIModel): CalendarEmployeeDisplay {
        var display = new CalendarEmployeeDisplay();

        display.Name = model.Name;
        display.Title = LicenceOrganisationRule.getTitleName(model.getIssuingOrgRule());

        display.EmployeeLastName = model.LastName ? model.LastName.trim() : "";

        display.Specialities = model.getServiceSpecializations().map(spe => spe.GetValue());

        display.ContactId = model.Model.Contact_id;
        display.ContactFacetId = model.Model.ContactFacet_id;
        display.EmployeeId = model.Id;
        display.ActiveSiteId = model.Model.ActiveSiteId;

        return display;
    }
}

export { CalendarEmployeeDisplay };
